import {batchDisposers, Service} from '../structure';

export default class SubDeferredDeeplinkService implements Service {
  subscribe() {
    return batchDisposers();
  }
}
